import { Injectable } from '@angular/core';
import { BehaviorSubject, forkJoin, ReplaySubject, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OtherService {

  private dataSubject = new ReplaySubject<any>(1);
  public data$: Observable<any> = this.dataSubject.asObservable();
  
  private questionsSource = new BehaviorSubject<any[]>([]);
  questions$ = this.questionsSource.asObservable();

  private questionsSourceAll = new BehaviorSubject<any[]>([]);
  questionsAll$ = this.questionsSourceAll.asObservable();

  private questionsStatistics = new BehaviorSubject<any[]>([]);
  statistics$ = this.questionsStatistics.asObservable();

  private questionsStatisticsAll = new BehaviorSubject<any[]>([]);
  statisticsAll$ = this.questionsStatisticsAll.asObservable();

  private sourceType = new BehaviorSubject<string>('noValue'); 
  sourceType$ = this.sourceType.asObservable(); 

  constructor() { }

  reverseArray<T>(array:T[]): T[]{
    return array.slice().reverse()
  }
  

  setQuestions(data: any[]) {
    this.questionsSource.next(data);
  }

  setQuestionsAll(data: any[]) {
    this.questionsSourceAll.next(data);
  }

  setStatistics(data: any[]) {
    this.questionsStatistics.next(data);
  }

  setStatisticsAll(data: any[]) {
    this.questionsStatisticsAll.next(data);
  }

  setSourceType(source: string) {
    this.sourceType.next(source);
  }

}
